/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { useState } from "react";

import { useCurrentUser } from "src/app/useCurrentUser";
import { BaseUser } from "src/classes/user";
import { StandardButton } from "src/components/UI/Buttons";

interface Props {
  user: BaseUser;
}
export function FollowButton({ user }: Props) {
  const currentUser = useCurrentUser()!;
  const usersFollowedByCurrentUser = currentUser.observe((state) => state.following);
  const currentUserIsFollowing = usersFollowedByCurrentUser.some((u) => u.snapshot.id === user.snapshot.id);
  const [loading, setLoading] = useState(false);

  const handleFollow = async () => {
    if (!loading) {
      setLoading(true);
      await currentUser.follow(user);
      setLoading(false);
    }
  };

  const handleUnfollow = async () => {
    if (!loading) {
      setLoading(true);
      await currentUser.unfollow(user);
      setLoading(false);
    }
  };

  return (
    <>
      {!currentUserIsFollowing && (
        <StandardButton highContrast onClick={handleFollow}>
          Follow
        </StandardButton>
      )}
      {currentUserIsFollowing && <StandardButton onClick={handleUnfollow}>Following</StandardButton>}
    </>
  );
}
